import React from 'react'
import { Button, Image, Modal } from 'semantic-ui-react'

export interface SuccessProps {
  title: string
  content: string | React.ReactElement
  actionText: string
  show: boolean
  onClose: () => void
}

export default function Success({ title, content, actionText, show, onClose }: SuccessProps) {
  return (
    <Modal open={show} onClose={onClose}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content image>
        <Image
          wrapped
          size="medium"
          src={require('assets/images/header.jpg')}
        />
        <Modal.Description>
          {content}
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button
          positive
          color="green"
          icon="checkmark"
          labelPosition="right"
          content={actionText}
          onClick={onClose}
        />
      </Modal.Actions>
    </Modal>
  )
}